import { ApiBaseService } from 'api/apibase.service';
import { AvailabilityOnDate } from 'api/availability-on-date/types/availability-on-date.interface';
import { AxiosPromise } from 'axios';
import { formatSQLDate } from 'utils/get-sql-date-format';

class AvailabilityOnDateApiService extends ApiBaseService {
  getDates(
    areaId: number,
    arrangementId: number | number[] | null,
    date: Date,
    zipCode: string,
  ): AxiosPromise<AvailabilityOnDate> {
    return this.apibase.get('availability/on-date', {
      params: {
        areaId,
        arrangementId: Array.isArray(arrangementId)
          ? Array.from(new Set(arrangementId)).join(',')
          : arrangementId,
        date: formatSQLDate(date),
        country: window.COUNTRY || 'US',
        zipCode,
        debug: new URL(window.location.href).searchParams.get('debug-flex'),
      },
    });
  }
}

export const availabilityOnDateService = new AvailabilityOnDateApiService();
